import CloseIcon from "@mui/icons-material/Close";
import { Box, Button, Stack, SvgIcon } from "@mui/material";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../../core/hooks/useStore";
import { RootState } from "../../core/store/store";
import FilterIntegrations from "./filter-integrations";
import projectsSlice from "./projects.slice";
import SearchProjects from "./search-projects";

const ProjectsFilter = () => {
  const dispatch = useAppDispatch();
  const filter = useSelector((state: RootState) => state.projects.filter);
  const handleClearFilter = () => {
    dispatch(projectsSlice.actions.resetFilter());
  };
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: 2,
      }}
    >
      <Box sx={{ flex: 1 }}>
        <SearchProjects />
      </Box>
      <Stack spacing={2} direction="row" alignItems="center">
        <FilterIntegrations />
        {filter.filtered && (
          <Button
            variant="text"
            size="small"
            startIcon={
              <SvgIcon fontSize="small">
                <CloseIcon />
              </SvgIcon>
            }
            onClick={handleClearFilter}
          >
            Clear
          </Button>
        )}
      </Stack>
    </Box>
  );
};

export default ProjectsFilter;